import React from 'react';
import { useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { isNativeApp } from '../../utils/platform';
import { NativeLoginPage } from '../../pages/NativeLoginPage';

const EXEMPT_ROUTES = ['/auth/callback', '/reset-password', '/policies/terms', '/policies/privacy'];

export const NativeAuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (!isNativeApp()) {
    return <>{children}</>;
  }

  if (EXEMPT_ROUTES.some((route) => location.pathname.startsWith(route))) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <NativeLoginPage />;
  }

  return <>{children}</>;
};
